import React from "react";
import Input from "../../../../Components/UI/Input";
import { useFormContext } from "react-hook-form";
import { useGetAllPaymodeQuery } from "../../../../AppQuries/master/Paymode/get-all-paymodes";
import { useGetBanksQuery } from "AppQuries/master/Bank/bank";

const BankBlock = () => {
  const {
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useFormContext();
  const { data: paymodes } = useGetAllPaymodeQuery({
    companyCode: watch("companyCode"),
  });

  const { data: banks } = useGetBanksQuery({
    companyCode: watch("companyCode"),
    isTrue: true,
  });

  const paymodeOptions = Array.isArray(paymodes?.data)
    ? paymodes?.data
        .filter((o) => o.isActive === true)
        .map((o) => ({
          id: o.paymentCode,
          label: o.paymentMode,
          value: o.paymentCode,
        }))
    : [];

    

  const bankOptions = Array.isArray(banks)
    ? banks
        .filter((o) => o.isActive === true)
        .map((o) => ({
          id: o.bankCode,
          label: o.bankShortCode,
          value: o.bankShortCode,
        }))
    : [];
    
  return (
    <>
      <div className="form-row row">
        <div className="col-md-4 mb-3">
          <Input
            name="paymentMode"
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors.paymentMode ? "is-invalid" : ""
            }`}
            label="Paymode Type"
            labelClassName="form-label"
            optionData={paymodeOptions}
            required={true}
            requiredMessage="Paymode Type is required"
            onChange={(selectedOption) => {
              setValue("paymentMode", selectedOption);
              trigger("paymentMode");
            }}
            defaultValue={watch("paymentMode")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="bankName"
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors.bankName ? "is-invalid" : ""
            }`}
            label="Bank"
            labelClassName="form-label"
            optionData={bankOptions}
            required={true}
            requiredMessage="Bank is required"
            onChange={(selectedOption) => {
              setValue("bankName", selectedOption);
              trigger("bankName");
            }}
            defaultValue={watch("bankName")}
          />
          {/* <Input
            name="bankName"
            type="text"
            placeholder="Bank Name"
            className={`form-control ${errors.bankName ? "is-invalid" : ""}`}
            label="Bank Name"
            labelClassName="form-label"
            required={true}
            requiredMessage="Bank Name is required"
          /> */}
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="accountNo"
            type="text"
            placeholder="Account No"
            className={`form-control ${errors.accountNo ? "is-invalid" : ""}`}
            label="Account No"
            labelClassName="form-label"
            required={false}
            requiredMessage="Account No is required"
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name="bankSwiftCode"
            type="text"
            placeholder="Bank Swift Code"
            className={`form-control ${errors.bankSwiftCode ? "is-invalid" : ""}`}
            label="Bank Swift Code"
            labelClassName="form-label"
            required={false}
            requiredMessage="Bank Swift Code is required"
          />
        </div>

        
      </div>
    </>
  );
};

export default BankBlock;
